<template>
       <el-dialog
            :title="kol_select_info.type==1?'拒绝达人':'选择达人'"
            :visible.sync="kol_select_info.kol_isSelect_flag"
            width="520px"
           >
            <el-form :model="form" ref="form" :rules="formRules">
                <div v-if='kol_select_info.type==2'>
                    <el-form-item>确认选择该达人吗？</el-form-item>
                    <el-form-item>对该达人的需求/备注信息
                        <el-input v-model="form.delete_remark" type="textarea" maxlength="100" show-word-limit placeholder="请输入备注"></el-input>
                    </el-form-item>
                </div>
                <div v-if='kol_select_info.type==1'>
                    <el-form-item>确认拒绝该达人吗？</el-form-item>
                    <el-form-item prop="delete_remark">拒绝原因：
                        <el-input v-model="form.delete_remark" type="textarea" maxlength="100" show-word-limit placeholder="请输入备注"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="kol_select_info.kol_isSelect_flag = false">取 消</el-button>
                <el-button type="primary" @click="saveKol('form')">确 定</el-button>
            </span>
        </el-dialog>
</template>
<script>
export default {
    name:'',
    props:{
        kol_select_info:{
            kol_isSelect_flag:true,
            type:'',
            cxdlid:'',
        },
    },
    data(){
        return{
            form:{
                kol_isSelect:'',
            },
            api: {
                editCpxDeal: "home/editCpxDeal", 
            },
            formRules: {
                delete_remark: [{
                    required: true, message: '请输入拒绝原因', trigger: 'blur'
                }]
            }
        }
    },
    created(){

    },
    methods:{
        saveKol(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.saveKolHandle();
                }
            })
        },
         // 保存选择达人/拒绝达人
        saveKolHandle(){
            let that= this;
            that.$httplogin({
                    method: 'POST',
                    url: that.api.editCpxDeal,
                    data:{
                        ...that.kol_select_info,
                        edit_type: that.kol_select_info.type,
                        delete_remark:that.form.delete_remark,
                        button_name:that.kol_select_info.type== 1 ? '客户拒绝' :''
                    }
            }).then((res) => {
                if(res && res.code ==1){
                    this.$message.success('操作成功')
                    this.kol_select_info.kol_isSelect_flag = false;
                   this.$emit('kolIsSelectClose')
                }else {
                    that.$message(res.msg);
                }
            }).catch((err) => {
                console.log(err);
            })
        }
    }
}
</script>